/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import LocationEdit from './Edit';
import MaterialTable from "material-table";
import { Spinner } from '../../Components/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import SideDrawer from './../../Components/SideDrawer';
import { createTheme, ThemeProvider } from "@mui/material";
import { UpdateDataService } from "../../Services/CrudServices";
import { DestroyResourceAction, LoadResourceAction } from "../../Redux/Actions/CrudActions";
import { isMobile } from "react-device-detect";

const LocationGrid = ({ columns, dataList, setDataList, Title, HandleDrawerCreate }) => {

    const ACTION_TYPE = "COMMON";

    const BACKEND_ROUTE = "locations";

    const theme = createTheme();

    const dispatch = useDispatch();

    const state = useSelector(state => state.common);

    const [id, setID] = React.useState(null);

    const [refreshTable, setRefreshTable] = React.useState(false);

    const [editDrawerStatus, setEditDrawerStatus] = React.useState(null);


    const HandleEditDrawaerOpen = (rowData) => {
        setID(rowData.id);
        setEditDrawerStatus(true);
    }

    const HandleEditDrawerClose = () => {
        if (editDrawerStatus) {
            setID(null);
            setEditDrawerStatus(false);
        }
    }

    React.useEffect(() => {
        if (refreshTable) {
            dispatch(LoadResourceAction(BACKEND_ROUTE, ACTION_TYPE));
        };
        setRefreshTable(false);
    }, [refreshTable]);

    const handleDelete = (oldData) => {
        var ID = oldData.id;
        dispatch(DestroyResourceAction(BACKEND_ROUTE, ID, ACTION_TYPE));
    }

    const HandleActiveInActiveStatus = (rowData) => {
        var update_status_route = `update_resource_status/Location/${rowData.id}`
        var newStatus = rowData.status === 1 ? false : true;
        var data = {'_method': 'put', 'status': newStatus};

        UpdateDataService(update_status_route, data)
        .then((res) => {
            setRefreshTable(true);
        }, error => {
            console.log("error");
        });
    }

    return (
        <ThemeProvider theme={theme}>
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    columns={columns.columns}
                    data={dataList}
                    title={isMobile ? '': Title}
                    isLoading={state.all.loading}
                    actions={[
                        {
                            icon: 'edit',
                            tooltip: 'Edit',
                            onClick: (event, rowData) => HandleEditDrawaerOpen(rowData)
                        },
                        {
                            icon: () => (isMobile)
                            ?<i className="fa-solid fa-plus theme-text-color-primary" style={{fontSize: '1.2rem'}}></i>
                            :<span className="btn btn-theme-primary btn-sm ml-2">Create a Location</span>,
                            tooltip: 'Create a Location',
                            isFreeAction: true,
                            onClick: (event, rowData) => HandleDrawerCreate()
                        },
                        rowData => ({
                            icon: () => (rowData.status) 
                            ? <i className="fa-solid fa-ban text-danger" style={{fontSize: '1.2rem'}}></i> 
                            : <i className="fa-solid fa-ban text-success" style={{fontSize: '1.2rem'}}></i> ,
                            tooltip: (rowData.status) ?  'Deactivate Location' : 'Activate Location',
                            onClick: (event, rowData) => HandleActiveInActiveStatus(rowData),
                        }),
                    ]}
                    editable={{
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    const data = [...dataList]
                                    data.splice(data.indexOf(oldData), 1);
                                    setDataList(data)
                                    handleDelete(oldData)
                                }, 600);
                            }),
                    }}
                />
            </div>
            <SideDrawer status={editDrawerStatus} handle={HandleEditDrawerClose} >
                {id && <LocationEdit ID={id} />}
            </SideDrawer>
        </ThemeProvider>
    );
}

export default LocationGrid;